<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <div class="mat-dialog-content__image">
      <img
        [src]="assetsUrl + '/images/cdt/icons/general-error-icon.svg'"
        alt=""
      />
    </div>
    <div class="mat-dialog-content__title">
      <p>Tuvimos un inconveniente con la carga de tus documentos</p>
    </div>
    <div class="mat-dialog-content__text">
      <p>
        No te preocupes, puedes continuar con la solicitud y uno de nuestros
        asesores te contactará para que hagas el envío.
      </p>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-dialog-close
    class="btn btn-degraded blue"
    type="button"
    (click)="onSubmit()"
    id="documents-to-charge-dialog-button"
  >
  Entendido
  </button>
</div>
